import React, { useState, useContext, useEffect } from 'react';
import { StateContext, DispatchContext } from 'context';
import { Themes } from 'styles';
import './solicitud-de-prestamo.css';
import { FormularioPpCt } from 'app/formulario-pp-ct';
import { FormularioUnipersonalEmpresa } from 'app/formulario-unipersonal-empresa';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const SolicitudDePrestamo = (props) => {
    const dispatch = useContext(DispatchContext);
    const state = useContext(StateContext);
    const indexTema = state && state.appReducer && state.appReducer.indexTema ? state.appReducer.indexTema : 0;
    const [verFormulario, setVerFormulario] = useState(false);
    const [verFormularioUnipersonal, setVerFormularioUnipersonal] = useState(false);
    const [verFormularioEmpresa, setVerFormularioEmpresa] = useState(false);
    useEffect(() => {
    }, []);
    return (
        <>
            <div id="solicitud-de-prestamos" className="w3-block">
                <div className="w3-content w3-padding">
                    <div className="w3-center">
                        <h1 style={{ color: Themes[indexTema].D1 }}>Solicitud de préstamo</h1>
                        {/* <p>Para agilizar tu pedido, sin moverte de tu casa u oficina y con la máxima reserva, solicita tu préstamo, completando el siguiente formulario:</p> */}
                        {(!verFormulario && !verFormularioUnipersonal && !verFormularioEmpresa) ? <button className="boton-formulario-online w3-margin-right w3-btn w3-xlarge w3-round-xxlarge w3-theme" onClick={() => setVerFormulario(true)}>Solicitar (Asalariado)</button> : null}
                        {(!verFormulario && !verFormularioUnipersonal && !verFormularioEmpresa) ? <button className="boton-formulario-online w3-margin-right w3-btn w3-xlarge w3-round-xxlarge w3-theme" onClick={() => setVerFormularioUnipersonal(true)}>Solicitar (Unipersonal)</button> : null}
                        {(!verFormulario && !verFormularioUnipersonal && !verFormularioEmpresa) ? <button className="boton-formulario-online w3-btn w3-xlarge w3-round-xxlarge w3-theme" onClick={() => setVerFormularioEmpresa(true)}>Solicitar (Empresa)</button> : null}
                        <br/>
                        <br/>
                        <br/>
                    </div>
                    {/* <div className="form-container bs-bbox">
                        <FormularioPpCt tipoSolicitud="1" />
                    </div> */}
                    {verFormulario ? <div>
                        <div className="w3-block w3-card w3-padding bs-bbox w3-animate-bottom">
                            <div className="w3-block" style={{ height: 50 }}>
                                <button className="close-btn w3-btn w3-light-gray" onClick={() => setVerFormulario(false)}>
                                    <FontAwesomeIcon icon={faTimes} />
                                </button>
                                <h1 style={{ color: Themes[indexTema].D1 }}>Solicitud Préstamo (Asalariado)</h1>
                            </div>
                            
                            <FormularioPpCt tipoSolicitud={1} />
                        </div>
                    </div> : null}
                    {verFormularioUnipersonal ? <div>
                        <div className="w3-block w3-card w3-padding bs-bbox w3-animate-bottom">
                            <div className="w3-block" style={{ height: 50 }}>
                                <button className="close-btn w3-btn w3-light-gray" onClick={() => setVerFormularioUnipersonal(false)}>
                                    <FontAwesomeIcon icon={faTimes} />
                                </button>
                                <h1 style={{ color: Themes[indexTema].D1 }}>Solicitud Préstamo (Unipersonal)</h1>
                            </div>
                            <FormularioUnipersonalEmpresa tipoSolicitud={2}/>
                        </div>
                    </div> : null}
                    {verFormularioEmpresa ? <div>
                        <div className="w3-block w3-card w3-padding bs-bbox w3-animate-bottom">
                            <div className="w3-block" style={{ height: 50 }}>
                                <button className="close-btn w3-btn w3-light-gray" onClick={() => setVerFormularioEmpresa(false)}>
                                    <FontAwesomeIcon icon={faTimes} />
                                </button>
                                <h1 style={{ color: Themes[indexTema].D1 }}>Solicitud Préstamo (Empresa)</h1>
                            </div>
                            <FormularioUnipersonalEmpresa tipoSolicitud={3}/>
                        </div>
                    </div> : null}
                </div>
            </div>
        </>
    );
}
export default SolicitudDePrestamo;